import { Button, notification } from "antd";
import type { AttachmentErrorCode, AttachmentValidationError } from "./attachmentValidation";

const LIMIT_MESSAGE =
  "Một số tệp không thể tải lên vì bạn chỉ có thể đính kèm tối đa 5 hình ảnh cùng lúc.";

const duplicateMessage = (name: string) => `Bạn đã tải lên tệp tên ${name}.`;

const tooLargeMessage = (name: string) =>
  name
    ? `Tệp "${name}" vượt quá dung lượng tối đa 20MB.`
    : "Mỗi tệp không được vượt quá dung lượng tối đa 20MB.";

const messageForError = (error: AttachmentValidationError): string => {
  switch (error.code) {
    case "limit":
      return LIMIT_MESSAGE;
    case "duplicate":
      return duplicateMessage(error.name ?? "");
    case "tooLarge":
      return tooLargeMessage(error.name ?? "");
    default:
      return LIMIT_MESSAGE;
  }
};

export const showAttachmentError = (
  error: AttachmentValidationError | AttachmentErrorCode,
  name?: string,
) => {
  const normalized: AttachmentValidationError =
    typeof error === "string"
      ? { code: error, kind: "image", name }
      : error;

  const key = `attachment-${normalized.code}-${normalized.name ?? "limit"}-${Date.now()}`;

  notification.open({
    key,
    message: messageForError(normalized),
    placement: "bottomLeft",
    duration: 4.5,
    btn: (
      <Button type="link" size="small" onClick={() => notification.destroy(key)}>
        Đóng
      </Button>
    ),
  });
};

export const showFirstAttachmentError = (errors: AttachmentValidationError[]) => {
  if (errors.length === 0) {
    return;
  }
  showAttachmentError(errors[0]);
};
